module.exports = __webpack_public_path__ + "static/media/Filter.1ba439d4.svg";